$(document).ready(function() {
    var agree_gdpr = false;
    var agree_marketing = false;

    $('#new_custumer_submit').on('click', function() {
        if ($('#agree_gdpr').is(':checked') || ($('#agree_gdpr').data("required") == 'false')) {
            $('#error_agree_gdpr').html('');
            agree_gdpr = true;
        }else {
            const message = $('#agree_gdpr').data("message");
            $('#error_agree_gdpr').html('<p class="error_text_create_account">'+message+'</p>');
        }
        /*
        if ($('#agree_marketing').is(':checked') || ($('#agree_marketing').data("required") == 'false')) {
            $('#error_agree_marketing').html('');
            agree_marketing = true;
        }else {
            const message = $('#agree_marketing').data("message");
            $('#error_agree_marketing').html('<p class="error_text_create_account">'+message+'</p>');
        }
          */

        if(agree_gdpr){
            $(this).submit();
        }else{
            return false;
        }
    });
});